<template lang="pug">
  .new-cron-task-form.columns
    b-loading(:active="isLoading")

    .column.is-6: .box
      div.columns
        div.column
          select-platform(
            label="Платформа*",
            v-model="value.platform_id",
            :data.sync="value.platform",
            type="active"
          )
        div.column
          b-field(label="Приоритет*", :type="errors && errors.priority ? 'is-danger' : ''", :message="errors.priority")
            b-select(v-model="value.priority")
              option(:value="1")
                | Обычный
              option(:value="2")
                | Высокий
        div.column
          b-field(label="Сложность*", :type="errors && errors.difficulty ? 'is-danger' : ''", :message="errors.difficulty")
            b-select(v-model="value.difficulty")
              option(:value="1")
                | Обычная
              option(:value="2")
                | Высокая

      b-field(label="Команда*", :type="errors && errors.command ? 'is-danger' : ''", :message="errors.command")
        b-input(v-model="value.command", placeholder="Например, medpred:platform-daily")

      br

      b-checkbox(v-model="value.is_test")
        | Тестовая задача &nbsp;
      b-checkbox(v-model="value.is_complex")
        | Составная задача

      br

      p.mt-2 Статус:
        b.pl-2 wait
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'new-cron-task-form',
  props: {
    value: Object,
    errors: Object,
  },

  data: () => ({
    isLoading: true,
  }),

  computed: {
    ...mapGetters(['user']),
  },

  created() {
    this.isLoading = false;
  },
};
</script>
